/**
 * 导出 => 所有状态
 * 操作历史 => 所有状态
 * 转单assignTo => 纸质票打印之前 / 实体卡mail之前  即 1, 3
 * 打印/批量打印 => printed之前  即 1
 * 重新打印/批量重新打印 => 打印之后, mailed之前 => 2,3
 * mail/导入快递信息(即批量mail) => mailed之前, printed后 2,3
 * regain => wait for regain 即 6
 *
 */
// 订单面板 - 区分邮寄和自取

import { websiteMapper } from "./const";

import { bookingStatusConst, CONST_waiting_for_regain } from "./utils/const";
import RegainMixin from "../mixins/regain";

export default function() {
  const statusMap = {
    "-1": "All",
    "0": "To Confirm",
    "1": this.$t("ffm_to_print"),
    "2": "Printed",
    "3": this.$t("ffm_waiting_for_mail"),
    "4": "Mailed",
    "5": this.$t("ffm_waiting_for_pick_up"),
    "6": this.$t("ffm_waiting_for_regain"),
    "7": "To Refund",
    "8": "Finished"
  };
  return {
    // 按钮状态
    /** tabs
     * -1:all
     * 0:to_upload => not here
     * 1:to_print
     * 2:printed
     * 3:waiting_for_mail
     * 4:mailed
     * 5:mailing_for_pick_up
     * 6:waiting_for_regain
     * 7:to_refund
     * 8:finished
     */
    buttonRefer: {
      // * 导出 => 所有状态
      export: [-1, 1, 2, 3, 4, 5, 6, 7, 8],
      // * 操作历史 => 所有状态
      history: [-1, 1, 2, 3, 4, 5, 6, 7, 8],
      // * 只有toprint
      assignTo: [1],
      // batchAssignTo 批量转单
      batchAssignTo: [1, 3, 5],
      // * 打印 printed之前  即 1
      print: [1],
      // * 批量打印 => printed之前  即 1
      batchPrint: [1],
      // * 批量重新打印
      batchReprint: [2, 3, 5],
      // * 重新打印 => 打印之后, mailed/pickup之前 => 2,3
      reprint: [2, 3, 5],
      // * mail => mailed之前, printed后 2,3
      mail: [2, 3],
      // * 导入快递信息(即批量mail)
      importDelivery: [2, 3],
      // * regain => wait for regain 即 6
      regain: [6],
      // * redeem
      voucher: [5],
      // * 更改物流信息 remail
      remail: [4],
      // * request-reupload
      requestReupload: [1, 2, 3, 5]
    },
    // places
    fullfillment_center_options: [],
    // assignTo地区选项
    assign_ops: [],
    form: {
      model: {
        order_no: "",
        // [Fulfillment Method removed] ticket_type: "",
        booking_time_start: "",
        booking_time_end: "",
        travel_time_start: "",
        travel_time_end: "",
        mailing_time_start: "",
        mailing_time_end: "",
        fulfillment_goods: [],
        time: [],
        time_type: "booking",
        search_type: "order_no",
        keywords: "",
        template_id: "",
        physical_type: []
      },
      rules: {},
      // all form item
      rows: [
        {
          label: "Search",
          type: "select",
          prop: "search_type",
          customClass: "filter-by-long",
          required: false,
          width: "169px",
          options: [
            {
              value: "order_no",
              label: "Order Number"
            },
            {
              value: "booking_reference_no",
              label: "Booking Reference Id"
            },
            {
              value: "logistics_no",
              label: "Tracking Number"
            },
            {
              value: "customer_name",
              label: "Customer Name"
            },
            {
              value: "travel_name",
              label: "Travel Name"
            }
          ]
        },
        {
          type: "text",
          prop: "keywords",
          // customClass: "order-no",
          placeholder: "Please Input",
          required: false,
          width: "320px"
        },
        {
          label: this.$t("ffm_time_type"),
          type: "select",
          prop: "time_type",
          clearable: false,
          customClass: "filter-by",
          required: false,
          width: "140px",
          options: [
            {
              value: "booking",
              label: this.$t("ffm_booking_time")
            },
            {
              value: "travel",
              label: this.$t("ffm_travel_date")
            },
            {
              value: "mailing",
              label: this.$t("ffm_mailing_date")
            }
          ]
        },
        {
          label: "",
          type: "daterange",
          prop: "time",
          customClass: "time-range",
          placeholder: this.$t("ffm_pls_select_time_range"),
          required: false,
          width: "240px"
        },
        {
          label: this.$t("ffm_products"),
          // 便于筛选
          key: "templates",
          type: "select",
          prop: "template_id",
          placeholder: "Please select",
          required: false,
          clearable: true,
          width: "169px",
          options: [],
          customClass: "filter-by-long"
        },
        {
          key: "suppliers",
          type: "select",
          prop: "physical_type",
          placeholder: "Please select",
          required: false,
          multiple: true,
          clearable: true,
          options: []
        },
        // [Fulfillment Method removed] ticket_type radio filter
        // {
        //   label: this.$t("ffm_method"),
        //   type: "radio",
        //   prop: "ticket_type",
        //   required: false,
        //   width: "300px",
        //   options: [
        //     {
        //       value: "",
        //       label: "All"
        //     },
        //     {
        //       value: 2,
        //       label: this.$t("ffm_pick_up")
        //     },
        //     {
        //       value: 1,
        //       label: this.$t("ffm_mailing")
        //     }
        //   ]
        // },
        {
          type: "operation",
          width: "1400px",
          itemCustomClass: "operation-buttons",
          btns: [
            {
              label: "Search",
              type: "primary",
              method: "submit"
            },
            {
              label: "Reset",
              method: "reset"
            }
          ]
        }
      ]
    },
    /** tabs
     * -1:all
     * 0:to_upload => not here
     * 1:to_print
     * 2:printed
     * 3:waiting_for_mail
     * 4:mailed
     * 5:mailing_for_pick_up
     * 6:waiting_for_regain
     * 7:to_refund
     * 8:finished
     */
    statuses: [
      {
        value: "-1",
        label: "All",
        key: "all"
      },
      {
        value: "1",
        label: this.$t("ffm_to_print"),
        key: "to_print"
      },
      {
        value: "2",
        label: this.$t("ffm_printed"),
        key: "printed"
      },
      {
        value: "3",
        label: this.$t("ffm_waiting_for_mail"),
        key: "waiting_for_mail"
      },
      {
        value: "4",
        label: this.$t("ffm_mailed"),
        key: "mailed"
      },
      {
        value: "5",
        label: this.$t("ffm_waiting_for_redeem"),
        key: "waiting_for_pick_up"
      },
      {
        value: "6",
        label: this.$t("ffm_waiting_for_regain"),
        key: "waiting_for_regain"
      },
      {
        value: "7",
        label: this.$t("ffm_to_refund"),
        key: "to_refund"
      },
      {
        value: "8",
        label: this.$t("ffm_finished"),
        key: "finished"
      },
      {
        value: "0",
        label: "Manual Order",
        key: "to_upload"
      }
    ],
    // 订单面板 - 区分邮寄和自取
    card: {
      // 邮寄
      items_mail: [
        {
          label: this.$t("Booking ID:"),
          key: "ticket_id"
        },
        {
          label: this.$t("ffm_method"),
          key: "ticket_type",
          format: val => {
            const typeMap = {
              1: "Mailing",
              2: "Pick Up"
            };
            return typeMap[Number(val)] || val;
          }
        },
        {
          label: this.$t("Booking Reference ID:"),
          key: "booking_reference_no"
        },
        {
          label: this.$t("Travel Time:"),
          key: "travel_time"
        },
        {
          label: this.$t("Phone Number:"),
          key: "phone_number"
        },
        {
          label: this.$t("KLK Voucher No.:"),
          key: "voucher_no"
        },
        {
          label: this.$t("Tracking Website:"),
          key: "tracking_website"
        },
        {
          label: this.$t("Tracking No:"),
          key: "logistics_no"
        },
        {
          label: this.$t("Nationality:"),
          key: "nationality"
        },
        {
          label: this.$t("Unit:"),
          key: "unit",
          formatter(item, card) {
            let arr = [];
            if (card.order_unit_detail && card.order_unit_detail.length) {
              card.order_unit_detail.forEach(v => {
                arr.push(`${v.amount} x ${v.price_type}`);
              });
            }
            return arr.join(",") || "-";
          }
        },
        {
          label: this.$t("Other:"),
          key: "express_text"
        }
      ],
      // 自取
      items_pickup: [
        {
          label: this.$t("Booking ID:"),
          key: "ticket_id"
        },
        {
          label: this.$t("ffm_method"),
          key: "ticket_type",
          format: val => {
            const typeMap = {
              1: "Mailing",
              2: "Pick Up"
            };
            return typeMap[Number(val)] || val;
          }
        },
        {
          label: this.$t("Booking Reference ID:"),
          key: "booking_reference_no"
        },
        {
          label: this.$t("Pick Up Date:"),
          key: "pick_up_date"
        },
        {
          label: this.$t("Travel Time:"),
          key: "travel_time"
        },
        {
          label: this.$t("KLK Voucher No.:"),
          key: "voucher_no"
        },
        {
          label: this.$t("Tracking Website:"),
          key: "tracking_website"
        },
        {
          label: this.$t("Nationality:"),
          key: "nationality"
        },
        {
          label: this.$t("Tracking No:"),
          key: "logistics_no"
        },
        {
          label: this.$t("Other:"),
          key: "express_text"
        },

        {
          label: this.$t("Unit:"),
          key: "unit",
          formatter(item, card) {
            let str = "";
            if (card.order_unit_detail && card.order_unit_detail.length) {
              card.order_unit_detail.forEach(v => {
                str += `${v.amount} x ${v.price_type} `;
              });
            }
            return str || "-";
          }
        }
      ]
    },
    // card => unit => expend
    table: {
      data: [],
      columns: [
        {
          prop: "id",
          label: this.$t("Unit ID")
        },
        {
          prop: "unit_no",
          label: this.$t("Unit No.")
        },
        {
          prop: "gender",
          label: this.$t("Gender"),
          formatter(row, column, cellValue) {
            let gender = {
              1: "male",
              2: "female",
              3: "Not set"
            };
            return gender[row.gender] || cellValue;
          }
        },
        {
          prop: "full_name",
          label: this.$t("Name")
        },
        {
          prop: "status",
          label: this.$t("Status"),
          formatter(row, column, cellValue) {
            let mes = statusMap[String(row.status)] || row.status;
            // 退款
            if (row.prev_status === 8 && row.status === 7) {
              mes = "Finished + Pending priority refund";
              return mes;
            }
            if (row.status === 8) {
              if (row.recycle === 1 && row.refunded === 1) {
                mes = "Already regained by fulfillment team + refunded";
              } else if (row.recycle === 0 && row.refunded === 1) {
                mes = "Refunded";
              } else {
                mes = "Finished";
              }
              return mes;
            }
            // 已回收 recycle 表示已经regain回收
            if (row.recycle === 1 && row.regain_type === 1) {
              if (row.refunded === 1) {
                mes = "Already regained by fulfillment team + refunded";
              } else {
                mes = "Already regained by fulfillment team + pending refund";
              }
              return mes;
            }
            // to be returned 回收, 需要判断回收之后的操作 regain_type
            if (row.status === 6) {
              return (
                mes +
                ["", "(to-refund)", "(re-upload)", "(to-print)"][
                  Number(row.regain_type)
                ]
              );
            }
            if (row.reverse === 1) {
              if (row.reverse_type === 2) {
                mes = mes + "(reprint)";
              } else if (row.reverse_type === 1) {
                mes = mes + "(re-upload)";
              }
            }
            return mes;
          }
        },
        {
          prop: "tracking_website",
          label: this.$t("ffm_tracking_websites"),
          render: (h, unit) => {
            let mapper = websiteMapper;
            let row = unit.row;
            let tracking = row.tracking_website;
            let url = mapper[tracking];
            return !url ? (
              <span>{tracking}</span>
            ) : (
              <span>
                <a href={url} target="_blank">
                  {tracking}
                </a>
              </span>
            );
          }
        },
        {
          prop: "logistics_no",
          label: this.$t("ffm_tracking_no")
        },
        {
          prop: "id",
          label: "Modify",
          render: (h, unit) => {
            let _this = this;
            let arr = [];
            // 逆向流而且to print
            if (unit.row.reverse === 1 && unit.row.status === 1) {
              arr.push(
                <el-dropdown
                  trigger="click"
                  onCommand={command =>
                    _this.handlePrintUnit(command, unit.row)
                  }
                >
                  <el-button type="text" size="small">
                    {_this.$t("ffm_print")}
                  </el-button>
                  &nbsp;
                  <el-dropdown-menu slot="dropdown">
                    {/* <el-dropdown-item command="cloud">
                      {_this.$t("ffm_cloud_print")}
                    </el-dropdown-item> */}
                    <el-dropdown-item command="local">
                      {_this.$t("ffm_local_print")}
                    </el-dropdown-item>
                  </el-dropdown-menu>
                </el-dropdown>
              );
            }
            // 逆向流且waiting for mail
            if (unit.row.reverse === 1 && unit.row.status === 3) {
              arr.push(
                <el-button
                  type="text"
                  size="small"
                  onClick={() => _this.showMailDialog(unit.row)}
                >
                  {_this.$t("mail")}
                </el-button>
              );
            }
            // 逆向流且waiting for mail
            if (unit.row.reverse === 1 && unit.row.status === 4) {
              arr.push(
                <el-button
                  type="text"
                  size="small"
                  onClick={() => _this.showMailDialog(unit.row, true, "unit")}
                >
                  mailed
                </el-button>
              );
            }
            // 逆向流且waiting for regain
            if (
              unit.row.status ===
                bookingStatusConst[CONST_waiting_for_regain] &&
              unit.row.recycle !== 1 &&
              !unit.row.isBookingRegain
            ) {
              arr.push(
                <el-button
                  type="text"
                  size="small"
                  onClick={() => _this.handleRegain("unit", unit, "edit")}
                >
                  regain
                </el-button>
              );
            } else if (
              unit.row.status !==
                bookingStatusConst[CONST_waiting_for_regain] &&
              RegainMixin.methods.hasRegainFilePath("unit", unit.row)
            ) {
              arr.push(
                <el-button
                  type="text"
                  size="small"
                  onClick={() => _this.handleRegain("unit", unit, "view")}
                >
                  regain detail
                </el-button>
              );
            }
            return arr.length ? <span>{arr}</span> : <span>-</span>;
          }
        }
      ]
    },
    // All Extra Infos/Basic Infos/For pick up options/For Mail Delivery
    exportOptions: [
      {
        label: "All Extra Infos",
        value: "1"
      },
      {
        label: "Basic Infos",
        value: "2"
      },
      {
        label: "For pick up options",
        value: "3"
      },
      {
        label: "For Mail Delivery",
        value: "4"
      }
    ],
    mail_form: {
      model: {
        tracking_website: "",
        tracking_no: ""
      },
      rows: [
        {
          label: this.$t("ffm_tracking_websites"),
          type: "select",
          prop: "tracking_website",
          required: false,
          width: "500px",
          placeholder: "Please select",
          options: [
            { label: "SF", value: "SF" },
            { label: "DHL", value: "DHL" },
            { label: "Roadbull", value: "Roadbull" },
            { label: "Alpha", value: "Alpha" },
            { label: "ThaiPost", value: "ThaiPost" },
            { label: "NinjaVan", value: "NinjaVan" },
            { label: "CJ Logistics", value: "CJ Logistics" },
            { label: "Citylink", value: "Citylink" },
            { label: "J&T", value: "J&T" },
            { label: "247 express", value: "247 express" },
            { label: "Maple", value: "Maple" }
          ]
        },
        {
          label: this.$t("ffm_tracking_no"),
          type: "text",
          width: "500px",
          prop: "tracking_no",
          placeholder: "Please input",
          required: false
        }
      ]
    },
    printTableCloumns: [
      {
        prop: "physical_type_name",
        label: this.$t("ffm_print_ticket_type")
      },
      {
        prop: "count",
        label: this.$t("ffm_quantity")
      },
      {
        prop: "id",
        label: "Modify",
        render: (h, group) => {
          let _this = this;
          return (
            <el-dropdown
              trigger="click"
              onCommand={command => _this.handlePrintGroup(command, group.row)}
            >
              <el-button type="text" size="small">
                {_this.$t("ffm_print")}
                <i class="el-icon-arrow-down" />
              </el-button>
              <el-dropdown-menu slot="dropdown">
                {/* <el-dropdown-item command="cloud">
                  {_this.$t("ffm_cloud_print")}
                </el-dropdown-item> */}
                <el-dropdown-item command="local">
                  {_this.$t("ffm_local_print")}
                </el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
          );
        }
      }
    ]
  };
}
